<template>
  <layout-panel hide-collapse
                :body-style="bodyStyle">
    <template slot="header">
      Q{{ questionIndex + 1 }} {{ types[question.type] }} OPT{{ index + 1 }} 属性设置
    </template>
    <el-form :model="option"
             size="mini">
      <el-form-item v-if="includes('jumpTargetId')"
                    label="跳转到题">
        <el-select v-model="option.jumpTargetId"
                   placeholder="请选择"
                   :disabled="disabled"
                   clearable>
          <el-option label="结束答题"
                     value="end"></el-option>
          <template v-if="scope === 'clb'">
            <el-option label="下一个产品"
                       value="nextProduct"></el-option>
            <el-option label="下一个模板"
                       value="nextTemplate"></el-option>
          </template>
          <el-option :label="getLabel(item, key)"
                     :value="item.id"
                     v-for="(item,key) in questions"
                     v-if="isJump(key)"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="includes('mutexOptions')"
                    label="选项互斥">
        <el-select v-model="option.mutexOptions"
                   placeholder="请选择"
                   multiple
                   :disabled="disabled"
                   @change="onUpdateExclusiveOption">
          <el-option :label="getOptionLabel(item, key)"
                     :value="item.id"
                     v-for="(item,key) in question.options"
                     v-if="item.id !== option.id"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="includes('referIds')"
                    label="审核参考">
        <el-select v-model="option.referIds"
                   placeholder="请选择"
                   multiple
                   collapse-tags
                   :disabled="disabled"
                   class="step-template-question-attr-multiple-select">
          <el-option :label="getLabel(item, key)"
                     :value="item.id"
                     v-for="(item,key) in questions"
                     :key="key"
                     v-if="key !== questionIndex"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="includes('takePhotoAuxiliaryLine') && option.needEvidence && question.evidenceType === 'photo'"
                    label="拍照辅助线">
        <el-select v-model="option.takePhotoAuxiliaryLine"
                   placeholder="请选择"
                   :disabled="disabled"
                   style="width: 166px;">
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,key) in takePhotoAuxiliaryLineType"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="includes('nextSelectDelay')"
                    label="等待时长">
        <el-input-number v-model="option.nextSelectDelay"
                         :min="0"
                         :controls="false"
                         :disabled="disabled"
                         style="width: 60px;">
        </el-input-number>
        <span> 秒</span>
      </el-form-item>
      <el-form-item v-if="includes('settlementType')"
                    label="结算方式">
        <el-select placeholder="请选择结算方式"
                   v-model="option.settlementType"
                   :disabled="disabled"
                   style="width: 83px;">
          <el-option label="不修改"
                     :value="0"></el-option>
          <el-option label="百分比金额"
                     :value="1"></el-option>
          <el-option label="固定金额"
                     :value="2"></el-option>
        </el-select>
        <template v-if="option.settlementType === 1">
          <el-input-number v-model="settlementAmountRatio"
                           :min="0"
                           :max="100"
                           :precision="2"
                           :controls="false"
                           :disabled="disabled"
                           style="width: 75px;">
          </el-input-number>
          <span> %</span>
        </template>
        <template v-if="option.settlementType === 2">
          <el-input-number v-model="option.settlementAmount"
                           :min="0"
                           :precision="2"
                           :controls="false"
                           :disabled="disabled"
                           style="width: 75px;">
          </el-input-number>
          <span> 元</span>
        </template>
      </el-form-item>
      <el-form-item v-if="includes('needEvidence')"
                    label="需要用户上传证据">
        <el-switch v-model="option.needEvidence"
                   :disabled="disabled || questionIndex===0"></el-switch>
      </el-form-item>
      <el-form-item v-if="includes('localFile')"
                    label="允许上传本地文件">
        <el-switch v-model="option.localFile"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="includes('intelligentCall')"
                    label="开启智能外呼">
        <el-switch v-model="option.intelligentCall"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="includes('autoIncreaseTaskGroupTarget')"
                    label="群组任务自动计入目标数">
        <el-switch v-model="option.autoIncreaseTaskGroupTarget"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="question.type === 'select'"
                    label="优先审核">
        <el-switch v-model="option.priorityReview"
                   :disabled="disabled"></el-switch>
      </el-form-item>

      <!--   输入类型以及输入范围   -->
      <attr-input-type v-if="includes('inputType')"
                       v-model="option"
                       :disabled="disabled"/>

      <el-form-item v-if="includes('required')"
                    label="必填">
        <el-switch v-model="option.required"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="['multitext','multiselect','imageMultiselect', 'select'].includes(question.type)"
                    label="数据标签">
        <el-input v-model="option.dataLabel"
                  placeholder="最多不超过50个字符"
                  :disabled="disabled"
                  maxlength="50"></el-input>
      </el-form-item>
    </el-form>
  </layout-panel>
</template>

<script>
import draggable from 'vuedraggable'
import { formRules } from '../step-template.rules.js'
import optionTypes from '@views/question-editor/format/convert-fields/option-types.js'
import AttrInputType from '@views/step-template/components/attrs/AttrInputType'

export default {
  components: {
    AttrInputType,
    draggable,
  },
  inject: ['scope'],
  props: {
    value: Object,
    index: Number,
    questions: Array,
    question: Object,
    questionIndex: Number,
    disabled: Boolean,
    bodyStyle: [String, Array, Object],
  },
  data () {
    return {
      formRules,
    }
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      types: state => state.types,
      takePhotoAuxiliaryLineType: state => state.takePhotoAuxiliaryLineType,
    }),
    option: {
      get () {
        if (this.questionIndex === 0) {
          this.value.needEvidence = false
        }
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    settlementAmountRatio: {
      get () {
        return this.option.settlementAmountRatio * 100
      },
      set (value) {
        this.option.settlementAmountRatio = value / 100
      },
    },
    inputMax: {
      get () {
        return this.option.inputMax
      },
      set (value) {
        let inputMax = value.toString().replace(/[^\d]/g, '')
        console.log(inputMax === '' ? null : Number(inputMax))
        this.option.inputMax = inputMax === '' ? null : Number(inputMax)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    getLabel (item, index) {
      return 'Q' + (index + 1) + '-' + item.title
    },
    getOptionLabel (item, key) {
      return 'OPT' + (key + 1) + ' ' + item.title
    },
    isJump (key) {
      return key > this.questionIndex
    },
    onUpdateExclusiveOption (mutexOptions) {
      this.cleanExclusiveOption()
      for (let i = 0; i < this.question.options.length; i++) {
        for (let n = 0; n < mutexOptions.length; n++) {
          if (this.question.options[i].id === mutexOptions[n]) {
            this.question.options[i].mutexOptions.push(this.option.id)
          }
        }
      }
    },
    cleanExclusiveOption () {
      for (let i = 0; i < this.question.options.length; i++) {
        for (let n = 0; n < this.question.options[i].mutexOptions.length; n++) {
          if (this.question.options[i].mutexOptions[n] === this.option.id) {
            this.question.options[i].mutexOptions.splice(n, 1)
          }
        }
      }
    },
    includes (field) {
      return optionTypes[this.question.type].includes(field)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateQuestionOptionAttr.vue